import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import ReportIcon from '@material-ui/icons/Report';
import ThumbsUpIcon from '@material-ui/icons/ThumbUp';

import React, { useState, useEffect } from 'react';

import { baseTheme } from '../../theme';

import { getPostDetails } from '../../services';
import { approveReportedPost, archivePost } from '../../services/posts';
import { IHighLight, IPost, IBlock } from '../../services/interfaces';

import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      heading: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
      },
      group: {
        fontWeight: 'bold',
      },
      postTitle: {
        fontSize: '1.4em',
        padding: theme.spacing(0),
        margin: theme.spacing(0),
      },
      postDate: {
        color: theme.palette.text.primary,
      },
      content: {
        color: theme.palette.text.primary,
        paddingTop: theme.spacing(1),
      },
      contentBody: {
        border: 'solid 1px #cdcdcd',
        paddingBottom: theme.spacing(1),
        minHeight: '200px',
        maxHeight: '500px',
        overflowY: 'scroll',
      },
      highLightBodySpacer: {
        paddingTop: theme.spacing(3),
      },
      highLight: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        borderBottom: `solid 1px ${theme.palette.text.disabled}`,
      },
      previewImage: {
        width: '100px',
        paddingRight: theme.spacing(1),
      },
    }),
);

const basePostData: IPost = {
  title: '',
  group: {
    id: '',
    name: '',
    type: 'Private',
  },
  date: '',
  owner: '',
  admins: [],
  creation: '',
  updated: '',
  content: '',
  linkUrl: '',
  tags: [],
  posted: false,
  public: false,
  searchTerms: [],
  archived: false,
};

export default function ModeratePost(props: any) {
  const [post, setPost] = useState<IPost>(basePostData);
  const [postModeratedMessage, setPostModeratedMessage] = useState('');
  const classes = useStyles(baseTheme);
  const postId = props.computedMatch.params.id;
  useEffect(() => {
    if (postId) {
      getPostDetails(postId).then((post) => {
        setPost(post);
        if (!post.reported) {
          setPostModeratedMessage('Post has already been restored.');
        }
        if (post.archived) {
          setPostModeratedMessage('Post has already been deleted.');
        }
      });
    }
  }, []);
  const renderHighlightImage = (image: string | undefined) => {
    return image ? (<img
        src={image}
        alt="preview"
        className={classes.previewImage}
    />) : <div className={classes.previewImage}>&nbsp;</div>;
  };
  const sorter = (a: any, b: any) => {
    if (a.order < b.order) {
      return -1;
    }

    if (a.order > b.order) {
      return 1;
    }

    return 0;
  };
  const renderHighlights = (highlights: IHighLight[]) =>
      highlights ?
          highlights.sort(sorter).map((highlight: IHighLight) => (
              <Grid container item xs={12} key={highlight.id} className={classes.highLight}>
                <Grid>
                  {renderHighlightImage(highlight.image)}
                </Grid>
                <Grid>
                  {highlight.content}
                </Grid>
              </Grid>
          ))
          : null;
  const approvePost = () => {
    approveReportedPost(post)
        .then(() => {
          setPostModeratedMessage('Post will be available to followers');
        });
  };
  const deletePost = () => {
    archivePost(post)
        .then(() => {
          setPostModeratedMessage('Post will not be available to followers');
        });
  };
  const highlights = post && post.highlights && post.highlights.length > 0 ? post.highlights : [];
  const groupName = post.group && post.group.name ? post.group.name : 'Post Name Placeholder';
  const postTitle = post.title ? post.title : 'Post Title Placeholder';
  const postDate = post.date ? post.date : 'Post Date Placeholder';
  let postContent =  'Post Content Placeholder';
  if (post.content) {
    postContent = '';
    const contentJson = JSON.parse(post.content);
    contentJson.blocks.forEach((block: IBlock) => {
      postContent += `${block.text}\n`;
    });
  }
  return (
    <Grid>
      {post &&
          <Grid>
              <Grid item container className={classes.heading}>
                  <Grid
                      item
                      container
                      direction="column"
                      xs={11}
                  >
                      <Grid item className={classes.group}>
                          {groupName}
                      </Grid>

                      <Grid item>
                          <h4 className={classes.postTitle}>
                              {postTitle}
                          </h4>
                      </Grid>

                      <Grid item className={classes.postDate}>
                          {postDate}
                      </Grid>
                  </Grid>

                  {!postModeratedMessage &&
                  <Grid item xs={1} className={classes.postTitle}>
                      Remove Post
                      <IconButton
                          onClick={deletePost}
                      >
                          <ReportIcon/>
                      </IconButton>
                      Approve Post
                      <IconButton
                          onClick={approvePost}
                      >
                          <ThumbsUpIcon/>
                      </IconButton>
                  </Grid>}
              </Grid>
              {postModeratedMessage}
            <Grid item className={classes.content}>
              <b>Content:</b>
              <Grid item className={classes.contentBody}>
                {postContent}
              </Grid>
              <div className={classes.highLightBodySpacer}></div>
              <b>Highlights:</b>
              {renderHighlights(highlights)}
            </Grid>
          </Grid>
      }
    </Grid>
  );
}
